export default __webpack_public_path__ + "static/ilya-pavlov-OqtafYT5kTw-unsplash-1e6660160d74059a9764407e0f12b282.jpg";